import { api, ApiError } from './api';
// WO-103：契约本地类型；没有计算、修改或数字提交函数。
export type CockpitProjection = {
  snapshotId: string | null; metricCode: string; valueState: 'CURRENT' | 'LAGGING' | 'UNKNOWN' | 'FAILED'; value: number | null; unit: string;
  scopeLabel: string; validAt: string | null; knownAt: string | null; computedAt: string | null; definitionVersion: number | null;
  formula: string; periodLabel: string; groups: Array<{ label: string; value: number }>; details: Array<{ label: string; value: string | number | null }>; missingSnapshot: boolean;
};
export type CockpitCard = CockpitProjection & { code: string; title: string; drilldownRoute: string; drilldownAllowed: boolean };
export type CockpitBoard = {
  domain: { displayName: string; purpose: 'SYNTHETIC' | 'REAL'; syntheticNotice: string | null }; generatedAt: string; cards: CockpitCard[];
  memberOrganizations: CockpitProjection; funnels: { clue: CockpitProjection; outcomes: CockpitProjection }; quality: CockpitProjection; freshness: CockpitProjection; blockingQualityCount: number | null;
  calendar: { year: number; state: 'AVAILABLE' | 'DENIED'; items: Array<{ title: string; startMonth: number; endMonth: number }> };
};
export const cockpitApi = { board: () => api<CockpitBoard>('/api/v1/cockpit/board') };
export function cockpitError(error: unknown) {
  if (error instanceof ApiError && error.reasonCode === 'NOT_ACTIVATED') return '本域驾驶舱尚未开通，统计口径与展示条件待确认。XXX-KPI-001';
  if (error instanceof ApiError && (error.status === 404 || error.status === 403)) return '当前授权范围无法查看驾驶舱，请核对我的授权。';
  return '暂时无法读取驾驶舱，请重试。';
}
